module.exports = __webpack_public_path__ + "img/goldenbear.1600d64e.png";